import type { TGuidanceApiData } from "@/api/user/guidance.types";

import type { TGuidancePersistedState } from "./types";

export const toPersistedState = (apiData: TGuidanceApiData): TGuidancePersistedState => ({
  tours: apiData.tours ?? {},
  tooltips: apiData.tooltips ?? {},
  banners: apiData.banners ?? {},
});

export const mergeGuidanceServerWins = (
  local: TGuidancePersistedState,
  server: TGuidancePersistedState
): TGuidancePersistedState => ({
  tours: { ...local.tours, ...server.tours },
  tooltips: { ...local.tooltips, ...server.tooltips },
  banners: { ...local.banners, ...server.banners },
});
